import { Helmet } from 'react-helmet-async'
import MySubscriptionView from '../views/MySubscription'
import { useLanguage } from '../i18n/LanguageContext'

const MySubscriptionPage = () => {
  const { t } = useLanguage()

  return (
    <>
      <Helmet>
        <title>{t('seo.mySubscriptionTitle')}</title>
        <meta name="description" content={t('seo.mySubscriptionDescription')} />
      </Helmet>
      <MySubscriptionView />
    </>
  )
}

export default MySubscriptionPage
